

const TitleTable = () => {
    return (
        <div className="flex flex-row-reverse items-center bg-primary-500 text-white text-right p-2">
            <p className="w-10"></p>
            <p className="w-52">نام</p>
            <p className="w-52">نام خانوادگی</p>
            <p className="w-52">نام کاربری</p>
            <p className="w-52">شماره موبایل</p>
            <p className="w-52"></p>
        </div>
    )
}
export default TitleTable;